import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";
import { Field, Input, Select, Toggle, SectionTitle } from "../primitives";
import { FITNESS_LEVELS, DRESS_SIZES } from "../constants";

export default function Step2Appearance({ form, set }) {
  const [meta, setMeta] = useState({
    body_types: [], hair_colors: [], eye_colors: [], bust_sizes: [],
    smoking_options: [], drinking_options: [],
  });
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/meta/services");
        setMeta({
          body_types: data.body_types || [],
          hair_colors: data.hair_colors || [],
          eye_colors: data.eye_colors || [],
          bust_sizes: data.bust_sizes || [],
          smoking_options: data.smoking_options || [],
          drinking_options: data.drinking_options || [],
        });
      } catch (e) { console.warn("[Step2Appearance] meta:", e); }
    })();
  }, []);

  const opt = (arr) => arr.map((v) => <option key={v} value={v}>{v}</option>);

  return (
    <div className="space-y-6">
      <SectionTitle icon={Sparkles} title="Appearance"
        subtitle="Optional but important — clients filter by these details." />

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
        <Field label="Height (cm)">
          <Input type="number" min={140} max={200}
            value={form.height} onChange={(e) => set({ height: e.target.value })}
            data-testid="app-height" />
        </Field>
        <Field label="Weight (kg)">
          <Input type="number" min={40} max={120}
            value={form.weight} onChange={(e) => set({ weight: e.target.value })}
            data-testid="app-weight" />
        </Field>
        <Field label="Body type">
          <Select value={form.body_type} onChange={(e) => set({ body_type: e.target.value })} data-testid="app-body">
            <option value="">—</option>{opt(meta.body_types)}
          </Select>
        </Field>
        <Field label="Hair color">
          <Select value={form.hair_color} onChange={(e) => set({ hair_color: e.target.value })} data-testid="app-hair">
            <option value="">—</option>{opt(meta.hair_colors)}
          </Select>
        </Field>
        <Field label="Eye color">
          <Select value={form.eye_color} onChange={(e) => set({ eye_color: e.target.value })} data-testid="app-eye">
            <option value="">—</option>{opt(meta.eye_colors)}
          </Select>
        </Field>
        <Field label="Bust">
          <Select value={form.bust_size} onChange={(e) => set({ bust_size: e.target.value })} data-testid="app-bust">
            <option value="">—</option>{opt(meta.bust_sizes)}
          </Select>
        </Field>
        <Field label="Dress size">
          <Select value={form.dress_size} onChange={(e) => set({ dress_size: e.target.value })} data-testid="app-dress">
            <option value="">—</option>{opt(DRESS_SIZES)}
          </Select>
        </Field>
        <Field label="Shoe size (EU)">
          <Input type="number" min={34} max={45}
            value={form.shoe_size} onChange={(e) => set({ shoe_size: e.target.value })}
            data-testid="app-shoe" />
        </Field>
        <Field label="Fitness level">
          <Select value={form.fitness_level} onChange={(e) => set({ fitness_level: e.target.value })} data-testid="app-fitness">
            <option value="">—</option>{opt(FITNESS_LEVELS)}
          </Select>
        </Field>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Smoking">
          <Select value={form.smoking} onChange={(e) => set({ smoking: e.target.value })} data-testid="app-smoking">
            <option value="">—</option>{opt(meta.smoking_options)}
          </Select>
        </Field>
        <Field label="Drinking">
          <Select value={form.drinking} onChange={(e) => set({ drinking: e.target.value })} data-testid="app-drinking">
            <option value="">—</option>{opt(meta.drinking_options)}
          </Select>
        </Field>
      </div>

      <div className="grid grid-cols-2 gap-4 pt-1">
        <div className="flex items-center justify-between px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle checked={form.tattoos} onChange={(v) => set({ tattoos: v })} label="Tattoos" testid="app-tattoos" />
        </div>
        <div className="flex items-center justify-between px-3 py-3 rounded-lg bg-stone-900/50 border border-stone-800">
          <Toggle checked={form.piercings} onChange={(v) => set({ piercings: v })} label="Piercings" testid="app-piercings" />
        </div>
      </div>
    </div>
  );
}
